import { Fragment, Suspense } from 'react';
import { Outlet } from 'react-router';
import Header from '@/components/Header/index';
import { SidebarProvider } from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/Sidebar/app-sidebar';

export default function MainLayout() {
  return (
    <Fragment>
      <div className="bg-provider">
        <SidebarProvider>
          <AppSidebar />
          <div className="min-w-0 flex-1 overflow-x-clip">
            <div className="transition-all duration-300 min-h-screen">
              {/* Header */}
              <Header />

              {/* Page Content */}
              <main className="relative z-[3] bg-provider lg:bg-transparent px-[1rem] md:px-[4rem] md:pb-[5rem] pb-[2rem] pt-[3rem]">
                <Suspense
                  fallback={
                    <div className="flex items-center justify-center h-screen fixed top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%]">
                      <div className=" animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                    </div>
                  }
                >
                  <Outlet />
                </Suspense>
              </main>
            </div>
          </div>
        </SidebarProvider>
      </div>
    </Fragment>
  );
}
